import { render, staticRenderFns } from "./payment-page-details.vue?vue&type=template&id=484f9595&scoped=true&"
import script from "./payment-page-details.vue?vue&type=script&lang=js&"
export * from "./payment-page-details.vue?vue&type=script&lang=js&"
import style0 from "./payment-page-details.vue?vue&type=style&index=0&id=484f9595&scoped=true&lang=css&"
import style1 from "./payment-page-details.vue?vue&type=style&index=1&id=484f9595&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f9595",
  null
  
)

export default component.exports